import React, { useState, useEffect } from 'react'
import AdminLayout from '../AdminLayout'
import ContentHeader from '../layout/ContentHeader'
import InvoiceHeader from '../layout/invoice/InvoiceHeader'
import InvoiceAddress from '../layout/invoice/InvoiceAddress'
import { Link, useParams, useNavigate } from 'react-router-dom';
import InvoiceTable from '../layout/invoice/InvoiceTable'
import { COMPANY_DETAILS, QUOTE_DETAILS, CONVERT_TO_INVOICE } from '../../../data/url'
import httpClient from '../../../http/HttpRequest'
import { useTranslation } from 'react-i18next';
import { useReactToPrint } from 'react-to-print';
import { generatePDF } from '../../pdf/GeneratePDF'
import Alert from '../../../feature/Alert'


export default function ViewQuote() {

  const [order, setOrder] = useState({});
  const [details, setOrderDetails] = useState([]);
  const [company, setCompanyDetails] = useState({});
  const [customer, setCustomer] = useState({});
  const { t } = useTranslation();

  const navigate = useNavigate();

  const { id } = useParams();

  const componentRef = React.useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  useEffect(() => {
    getOrderDetails();
    getCompanyDetails();
  }, []);


  const getOrderDetails = async (e) => {
    const res = await httpClient.post(QUOTE_DETAILS, { quote_id: id });
    if (res.requestStatus === "OK") {
      const result = res.result;
      if (result.status === 1) {
        let data = result.data.quote_details;
        data['invoice_date'] = data.date;
        data['valid_until'] = data.due_date;
        setOrder(data);
        setOrderDetails(result.data.details);
        setCustomer(result.data.customer);
      }
    }
  }

  const getCompanyDetails = async () => {
    const res = await httpClient.post(COMPANY_DETAILS, {});
    if (res.requestStatus === 'OK') {
      const result = res.result;
      if (result.status === 1) {
        setCompanyDetails(result.data);

      }
    };
  }

  const makePdf = () => {
    let filename = `${order.number}-QUOTE`;
    generatePDF(filename);
  };

  const convertToInvoice = async() => {
    const res = await httpClient.post(CONVERT_TO_INVOICE, { quote_id: id });
    if (res.requestStatus === "OK") {
      const result = res.result;
      if (result.status === 1) {
        Alert.success(result.message);        
      }else{
        Alert.info(result.message);
      }
      navigate(`/root/invoices/view/${result.invoice_id}`);
    }
  }

  return (
    <AdminLayout>
      <div className="content-wrapper">
        <ContentHeader title="view_quote" subTitle="quotes" subTitleLink="root/quotes" />
        <div className="card col-md-11 m-auto" id="quotes">
          <div className="card-body" id="print_section" ref={componentRef}>
            <InvoiceHeader title="quote" number={`${order.prefix}-${order.number}`} />
            <InvoiceAddress title="quote_to" customer={customer} company={company} order={order} />
            <InvoiceTable title="bill_to" products={details} order={order} company={company} customer={customer} />
          </div>
          <div className='text-center'>
            <Link to={`/root/quotes/edit/${id}`} type="button" className="btn btn-sm btn-primary btn-icon-text m-1">
              {t('edit')}
            </Link>
            <button className="btn btn-sm btn-danger btn-icon-text m-1" onClick={makePdf}>{t('pdf')}</button>
            <button className="btn btn-sm btn-info btn-icon-text m-1" onClick={handlePrint}>{t('print')}</button>
            <button className="btn btn-sm btn-success btn-icon-text m-1" onClick={convertToInvoice}>{t('convert_to_invoice')}</button>
          </div>
        </div>
      </div>
    </AdminLayout>
  )
}
